/**
 * Copy text to the clipboard, falling back to a hidden textarea +
 * document.execCommand("copy") on browsers without the async Clipboard API.
 * Throws if the copy fails so callers can surface a manual-copy prompt.
 */
export const copyToClipboard = async (text: string): Promise<void> => {
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
    return;
  }
  // Fallback for older browsers
  const textArea = document.createElement("textarea");
  textArea.value = text;
  document.body.appendChild(textArea);
  textArea.select();
  try {
    const copied = document.execCommand("copy");
    if (!copied) {
      throw new Error("execCommand copy returned false");
    }
  } finally {
    textArea.remove();
  }
};
